


























































import Vue from 'vue';
import FlashingModal from '../components/FlashingModal.vue';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      isOn: false,
      instructionColProps: {
        xs: 24,
        sm: 8,
        class: 'instructionBox',
      },
    };
  },
  methods: {
    onSwitch() {
      this.isOn = !this.isOn;
    },
  },
  components: {
    FlashingModal,
  },
});
